import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MARKETING_ACTIVITY_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const  MarketingActivityReport = lazy(() =>
  import('../../../screens/MarketingActivityReport')
    .then(module => ({default: module.MarketingActivityReport})));

const MarketingActivityReportNavigation = [
  {
    path: ROUTE_MARKETING_ACTIVITY_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <MarketingActivityReport />
      </Suspense>
    ),
  },
];

export default MarketingActivityReportNavigation;
